import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/form')({
  staticData: { breadcrumb: 'Forms', breadcrumbKey: 'K_BREADCRUMB_FORMS' },
  component: FormLayout,
});

function FormLayout() {
  return <Outlet />;
}
